













import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import type { PropType } from '@vue/composition-api';
import { defineComponent, ref, computed } from '@vue/composition-api';
import { OptionMenuItemCallback } from '../options-menu/types/enums/option-menu-item-callback';
import type { DocumentPage } from '../types/document-page';
import VideoPlayer from '../video/player/components/VideoPlayer.vue';

export default defineComponent({
  components: {
    VideoPlayer,
  },
  props: {
    page: {
      type: Object as PropType<DocumentPage>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const currentVideoPlayTime = ref<number>(null);
    const showOptions = ref(false);

    const thumbUrl = computed(() => props.page.video?.thumbUrl);

    const options = computed(() => [
      {
        icon: 'edit',
        title: t('edit'),
        callback: OptionMenuItemCallback.Edit,
      },
      {
        icon: 'chevron-up-and-down',
        title: t('move'),
        callback: OptionMenuItemCallback.Move,
      },
      {
        icon: 'delete-bin',
        title: t('delete'),
        callback: OptionMenuItemCallback.Delete,
      },
    ]);

    const handleTimeUpdate = (playtime: number) => {
      currentVideoPlayTime.value = playtime;
    };

    const handlePause = () => {
      sendTrackingData();
    };

    const handleEnded = () => {
      sendTrackingData();
    };

    const handleShowOptions = () => {
      showOptions.value = true;
    };

    const hideOptions = () => {
      showOptions.value = false;
    };

    const sendTrackingData = () => {
      if (!currentVideoPlayTime.value) {
        return;
      }
      emit('trackVideo', { id: props.page.video.id, viewDuration: currentVideoPlayTime.value });
      currentVideoPlayTime.value = null;
    };

    return {
      currentVideoPlayTime,
      thumbUrl,
      options,
      showOptions,
      handleTimeUpdate,
      handlePause,
      handleEnded,
      handleShowOptions,
      hideOptions,
      sendTrackingData,
    };
  },
});
